/* eslint-disable max-len */
import { useAppDispatch, useAppSelector } from '@/utils/hook';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { isMobile } from 'react-device-detect';
import Banner from '../RoutePage/Banner';
import PageHeader from '../RoutePage/Header';
// import CMSComponent from './CMS';
import BannerDiscount from '@/components/BannerDiscount';
import {
  addAllPoints, addPoints, adjustAllPassengers, adjustSeatClass,
} from '@/slices/area/slices/searchFlightFormSlice';
import { TSelectedDate } from '@/slices/calendar';
import { setSelectedDate } from '@/slices/calendar/calendarSlice';
import { removeFlight, removeReturnFlight } from '@/slices/selectedFlight/slices/selectedFlightSlice';
import { getParamsFlightMapping } from '@/utils/paramsMapping';
import { pr } from '@/utils/pxToRem';
import { slugify } from '@/utils/stringConvert';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import BreadcrumbsSeo from '../BreadcrumbsSeo';
import HeaderTabs from '../HeaderTabs';
import { SEOPageWrapper } from '../SEOPageWrapper';
import PathBreadcrumbs from './PathBreadcrumbs';
import SectionManager from './SectionManager';
import DataStructuredHead from './DataStructuredHead';

const RouteToCityPageComponent = ({ toPoint, headerTabs }: any) => {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const [currToPoint, setCurrToPoint] = useState(toPoint);
  const {
    passenger: statePassenger, seatClass: stateSeatClass,
    startPoint, startPointHome, toPointHome,
  } = useAppSelector((state) => state.searchFlightForm);

  const routeName = `đi ${currToPoint?.location}`;
  let routeCode = `${currToPoint?.airports[0]?.airportCode}`;
  let routeCodeReturn = `${currToPoint?.airports[0]?.airportCode}`;

  if ((!startPoint && startPointHome) || (startPoint && startPointHome && startPoint.id !== startPointHome.id)) {
    // setTimeout(() => {
    dispatch(addPoints({
      type: 'from',
      data: startPointHome,
    }));
    // });
  }
  if (currToPoint && toPointHome && currToPoint.id !== toPointHome.id) {
    // setTimeout(() => {
    dispatch(addPoints({
      type: 'to',
      data: toPointHome,
    }));
    // });
    setCurrToPoint(toPointHome);
    routeCode = `${startPoint?.airports[0]?.airportCode}-${currToPoint?.airports[0]?.airportCode}`;
    routeCodeReturn = `${currToPoint?.airports[0]?.airportCode}-${startPoint?.airports[0]?.airportCode}`;
  }
  if (startPoint) {
    routeCode = `${startPoint?.airports[0]?.airportCode}-${currToPoint?.airports[0]?.airportCode}`;
    routeCodeReturn = `${currToPoint?.airports[0]?.airportCode}-${startPoint?.airports[0]?.airportCode}`;
  }

  const wrapperRef = React.useRef(null);
  const selectedDate = {
    depart: new Date(),
    return: null,
  };

  const onSearchFlight = (date: TSelectedDate) => {
    const tmpStartPoint = startPoint;
    const tmpToPoint = currToPoint;
    const tmpSelectedDate = date || selectedDate;

    const tmpPassenger = statePassenger;
    const tmpSeatClass = stateSeatClass;
    if (
      !tmpStartPoint
      || !tmpToPoint
      || !tmpSelectedDate
      || !tmpPassenger
      || !tmpSeatClass
    ) {
      return;
    }
    dispatch(removeFlight());
    dispatch(removeReturnFlight());

    dispatch(addAllPoints([
      {
        data: tmpStartPoint,
        type: 'from',
      },
      {
        data: tmpToPoint,
        type: 'to',
      },
    ]));
    dispatch(setSelectedDate({ dateObj: JSON.stringify(tmpSelectedDate) }));
    dispatch(adjustAllPassengers(tmpPassenger));
    dispatch(adjustSeatClass({ seatClass: tmpSeatClass }));

    const path = getParamsFlightMapping({
      tmpPassenger,
      tmpSeatClass,
      tmpSelectedDate,
      tmpToPoint,
      tmpStartPoint,
    });
    router.push(path);
  };
  const routeId = startPoint ? `${startPoint.id}.${currToPoint.id}` : currToPoint.id;

  return (
    <SEOPageWrapper
      ref={wrapperRef}
    >
      <PageHeader />
      {/* <DataStructuredHead
        routeName={routeName}
        endPoint={currToPoint}
        routeId={routeId}
        routeDate={new Date()}
        // {...structuredData}
      /> */}
      {/* {!isMobile ? (
        <PathBreadcrumbs
          endLocation={currToPoint.location}
          endLocationId={currToPoint.id}
        />
      ) : null} */}
      <Stack>
        <Banner name={`${routeName}`} />
        <HeaderTabs />
      </Stack>
      <Box sx={{
        backgroundColor: 'white',
        marginBottom: '8px',
      }}
      >
        <BannerDiscount
          isHiddenTitle
          sx={{
            paddingX: '16px',
            paddingBottom: '16px',
          }}
          vehicleType={headerTabs === 0 ? 'flight' : 'bus'}
        />
      </Box>
      <SectionManager
        routeCode={routeCode}
        routeCodeReturn={routeCodeReturn}
        startPointHome={startPoint}
        toPointHome={currToPoint}
        sxWrapper={{
          px: pr`16px`,
          pt: pr`32px`,
        }}
        routeName={routeName}
        onSearchFlight={onSearchFlight}
      />
      <BreadcrumbsSeo
        sx={{
          background: '#EFF2F5',
          padding: '22px 16px',
        }}
        breadcrumbs={[
          {
            title: 'Goyolo.com',
            url: '/',
          },
          {
            title: 'Vé máy bay giá rẻ',
            url: '/vn/ve-may-bay.vi',
          },
          {
            title: `Vé máy bay đi ${toPoint?.location}`,
            url: `/vn/ve-may-bay/di-${slugify(toPoint?.location)}.${toPoint?.id}.vi`,
          },
        ]}
      />
    </SEOPageWrapper>
  );
};

export default React.memo(RouteToCityPageComponent);
